<div class="prices-disclaimer">
  <div class="prices-disclaimer__icon"></div>
  <div class="prices-disclaimer__text" i18n>
    Prices are based on the destination currency. If the total price is displayed in your local currency, please note that it is converted based on the exchange
    rate for the current week. The amount may vary at the time of enrolment.
  </div>
</div>
